import React,{Component} from 'react';
class About extends Component{
    render(){
        return(
            <div className="condiv">
                <h1 className="subtopic">About Me</h1>
                <h4>Hey there,</h4>
                <h1>I'm Khushi Chauhan</h1>
                <h3>Front-End Developer</h3>
                <br></br>
                <p>I started my journey in the world of computers from a young age,
                now I’m 21 years old, Pursuing my Bachelor's Degree in the field of Computer Science from
                Noida Institute of Engineering and Technology.  Web development is my center of interest, I always
                love the idea of cross-platform development, 1-n one code base deploy into almost
                any platform, which web technology like Javascript enables me to do.</p>
            </div>
        )
    }
}
export default About